<section class="pb-5">
    <div class="container">
        <div class="inner-sec">
            <div class="sec-head">
                <h1 class="sec-title text-capitalize">contact me</h1>
                <span class="block"></span>
            </div>
            <div class="form-wrapper">
                <form action="https://formspree.io/f/meqpbanz" method="POST">
                    <div class="d-flex flex-column">
                        <label>Your Name:</label>
                        <input class="text-input" type="text" name="name" id="text1" required>
                    </div>
                    <div class="d-flex flex-column my-sm-5 my-3">
                        <label>Your Email Address:</label>
                        <input class="text-input" type="email" name="email" id="email" required>
                    </div>
                    <div class="d-flex flex-column my-sm-5 my-3">
                        <div class="message">
                            <h2>Add Your Message</h2>
                        </div>
                        <textarea name="message" id="t1" required></textarea>
                    </div>
                    <input class="submit" type="submit" value="Send">
                </form>
            </div>
        </div>
    </div>
</section>